<i18n>
{
    "en_US": {
        "retry": "Retry...",
        "validate-email": "Validating your email"
    },
    "fr_FR": {
        "retry": "Réessayer...",
        "validate-email": "Validation de votre email..."
    }
}
</i18n>

<template>
    <form v-on:submit.prevent="retry">
        <h1 class="text-left" v-text="$t('validate-email')"></h1>
        <slot name="flashes" />
        <loader-basic-spinner v-if="pending.validate" class="blue" />

        <button class="btn btn-lg btn-primary btn-block" type="submit" v-bind:disabled="pending.validate">
            <loader-basic-spinner v-if="pending.validate" />
            <a v-else v-text="$t('retry')"></a>
        </button>
    </form>
</template>

<script>
    import LoaderBasicSpinner from "loaders/BasicSpinner";
    import { mapState, mapActions } from "vuex";

    export default {
        name: "Validate",
        mounted: function() {
            $(this.$el).bootstrapMaterialDesign();
            this.retry();
        },
        components: {
            LoaderBasicSpinner
        },
        computed: {
            ...mapState("user", ["pending"])
        },
        methods: {
            retry: function() {
                const link = this.$route.params.validation_link;
                this.validate(link)
                    .then(function() {
                        this.$Progress.finish();
                        this.$router.push({ name: "login" });
                    }.bind(this))
                    .catch(function() {});
            },
            ...mapActions("user", ["validate"])
        }
    }
</script>

<style scoped>
    h1 {
        margin-top: 20px;
        margin-bottom: 30px;
        color: #666;
        font-weight: 300;
        font-size: 20px;
    }
    button {
        margin-bottom: 0;
        margin-top: 50px;
        font-weight: 100;
        font-size: 18px !important;
        line-height: 1.3333333333;
    }
    .form-group label {
        font-weight: bold;
        font-size: 14px;
    }
</style>